import {
  SET_WIZARD_STEP,
  SET_WIZARD_SELECTED_ITEMS,
  CLEAR_WIZARD_SELECTED_ITEMS,
} from 'constants/actions';

const initialState = {
  step: null,
  selectedItems: [],
};

export default function wizard(
  state = initialState,
  { type, step, selectedItems },
) {
  switch (type) {
    case SET_WIZARD_STEP:
      return {
        ...state,
        step,
      };
    case SET_WIZARD_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems,
      };
    case CLEAR_WIZARD_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: [],
      };
    default:
      return state;
  }
}
